export default "__VITE_ASSET__BXlEd6jg__"